export const validations = {
  aadhaar_number: {
    required: "Please enter aadhaar number.",
    valid: "Please enter 12 digits aadhaar number.",
  },
  address: {
    required: "Please enter address.",
  },
  annual_income: {
    required: "Please enter annual income.",
    valid: "Minimum annual income should be 1,00,000.",
  },
  appointee_name: {
    required: "Please enter appointee name.",
  },
  appointee_dob: {
    required: "Please enter date of birth.",
    min: "Appointee is less than 18 years.",
    max: "Appointee is more than 100 years.",
    valid: "Please enter valid date of birth.",
  },
  appointee_email: {
    valid: "Please enter valid email.",
  },
  appointee_mobile: {
    required: "Please enter valid mobile number.",
    valid: "Please enter valid mobile number.",
  },
  appointee_relationship: {
    required: "Please enter appointee relationship.",
  },
  appointee_bank_account_holder_name: {
    required: "Please enter bank account holder name.",
  },
  appointee_bank_account_number: {
    required: "Please enter bank account number.",
  },
  appointee_bank_ifsc_code: {
    required: "Please enter bank IFSC code.",
    valid: "Please enter valid bank IFSC code.",
  },
  bank_account_holder_name: {
    required: "Please enter bank account holder name.",
  },
  bank_account_number: {
    required: "Please enter bank account number.",
  },
  bank_account_type: {
    required: "Please enter account type.",
  },
  bank_ifsc_code: {
    required: "Please enter IFSC code.",
    valid: "Please enter valid IFSC code.",
  },
  bank_micr_code: {
    required: "Please enter micr code.",
    valid: "Please enter valid micr code.",
  },
  bank_name: {
    required: "Please enter bank name.",
  },
  dob: {
    required: "Please enter date of birth.",
    min: "Minimum age should be 18 years.",
    max: "Maximum age should be ",
    valid: "Please enter valid date of birth.",
  },
  annualIncome: {
    required: "Please enter annual income.",
    valid: "Minimum value should be ",
  },
  education: {
    required: "Please select education.",
  },
  email: {
    required: "Please enter email id.",
    valid: "Please enter valid email id.",
  },
  empcode: {
    required: "Please enter employee id.",
  },
  father_name: {
    required: "Please enter father name.",
  },
  gender: {
    required: "Please enter gender.",
  },
  height: {
    required: "Please enter height.",
    valid: "Please enter valid height.",
  },
  mobile: {
    required: "Please enter valid mobile number.",
    valid: "Please enter valid mobile number.",
  },
  name: {
    required: "Please enter full name.",
  },
  nominee_name: {
    required: "Please enter nominee name.",
  },
  nominee_dob: {
    required: "Please enter date of birth.",
    min: "Nominee dob should not be a future date.",
    max: "Nominee is more than 100 years.",
    valid: "Please enter valid date of birth.",
  },
  nominee_email: {
    valid: "Please enter valid email.",
  },
  nominee_mobile: {
    required: "Please enter valid mobile number.",
    valid: "Please enter valid mobile number.",
  },
  nominee_relationship: {
    required: "Please enter nominee relationship.",
  },
  nominee_bank_account_holder_name: {
    required: "Please enter bank account holder name.",
  },
  nominee_bank_account_number: {
    required: "Please enter bank account number.",
  },
  nominee_bank_ifsc_code: {
    required: "Please enter bank IFSC code.",
    valid: "Please enter valid bank IFSC code.",
  },
  organisation_name: {
    required: "Please enter organisation name.",
  },
  pan_number: {
    required: "Please enter pan number.",
    valid: "Please enter valid pan number.",
  },
  password: {
    required: "Please enter password.",
    min: "Min 6 characters long password.",
  },
  weight: {
    required: "Please enter weight.",
    valid: "Please enter valid weight.",
  },
};
